// extracted by mini-css-extract-plugin
export default {"container":"styles_container__o56kK","primary":"styles_primary__ZqUQP","secondary":"styles_secondary__s5WWF","text":"styles_text__rfEHf"};